import React from 'react';
import { SFButton, SFIcon } from 'sfui';
import styles from './NoInitiatives.module.scss';
import { useHistory } from 'react-router';

export const NoInitiatives = (): React.ReactElement<{}> => {
  const history = useHistory();
  return (
    <div className={styles.noInitiatives}>
      <div className={styles.content}>
        <div className={styles.icon}>
          <SFIcon icon="Preferences-1" size={96} />
        </div>

        <h2 className={styles.title}>No initiatives yet</h2>

        <p className={styles.subTitle}>
          The latest initiatives will be displayed here.
        </p>

        <SFButton
          className={styles.createInitiativeBtn}
          onClick={() =>
            history.push('/app/settings', { section: 'initiatives' })
          }
          variant="contained"
          color="primary"
        >
          Create a Initiative
        </SFButton>
      </div>
    </div>
  );
};
